import DisableMedia from 'js/components/disable-media'
import UnregisterBox from 'js/pages/profile/_unregister-box'
import evaluatePasswordPolicy, {PASSWORD_POLICY_I18N_KEYS} from 'js/lib/password-policy'
import {mapGetters} from 'vuex'
import PasswordPolicyModal from 'js/components/password-policy-modal'
import PasswordInput from 'js/components/password-input'

import template from 'js/pages/profile/index.pug'

const isCompletedPassword = value => typeof value === 'string' && value.trim() !== ''

export default Vue.extend({
  name: 'profile-page',
  template: template(),
  components: {
    DisableMedia,
    UnregisterBox,
    PasswordPolicyModal,
    PasswordInput
  },

  data() {
    return {
      modifyEmail: '',
      modifyName: '',
      modifySurname: '',
      modifySurname2: '',
      modiPhone: '',
      modifyEmailError: undefined,
      modifyNameError: undefined,
      modifySurnameError: undefined,
      modifySurname2Error: undefined,
      modiPhoneError: undefined,
      modifyCurrentPassword: '',
      modifyCurrentPasswordError: undefined,
      modifyPassword: '',
      modifyPasswordError: undefined,
      modifyPasswordConfirmation: '',
      modifyPasswordConfirmationError: undefined,
      showPasswordPolicyModal: false,
      modifyPasswordValidationTouched: {
        currentPassword: false,
        password: false,
        passwordConfirmation: false
      },
      showUnregisterBox: false,
      showDisableMediaBox: false,
      disableMedias: {}
    }
  },

  computed: {
    ...mapGetters('appConfig', ['getPasswordPolicy']),

    modifyPasswordPolicyViolation() {
      return evaluatePasswordPolicy({
        policy: this.getPasswordPolicy,
        password: typeof this.modifyPassword === 'string' ? this.modifyPassword.trim() : '',
        email: this.$user?.email
      }).violations[0]
    },

    isUpdatePasswordSubmitEnabled() {
      return isCompletedPassword(this.modifyCurrentPassword) &&
        isCompletedPassword(this.modifyPassword) &&
        !this.modifyPasswordPolicyViolation &&
        this.modifyPasswordConfirmation === this.modifyPassword
    }
  },

  watch: {
    modifyCurrentPassword() {
      this.modifyPasswordValidationTouched.currentPassword = true
      this.validateUpdatePasswordField('currentPassword')
    },

    modifyPassword() {
      this.modifyPasswordValidationTouched.password = true
      this.validateUpdatePasswordField('password')

      if (this.modifyPasswordValidationTouched.passwordConfirmation) {
        this.validateUpdatePasswordField('passwordConfirmation')
      }
    },

    modifyPasswordConfirmation() {
      this.modifyPasswordValidationTouched.passwordConfirmation = true
      this.validateUpdatePasswordField('passwordConfirmation')
    }
  },

  created() {
    if (this.$user) {
      this.modifyEmail = this.$user.email
      this.modifyName = this.$user.name
      this.modifySurname = this.$user.surname
      this.modifySurname2 = this.$user.surname2
      this.modiPhone = this.$user.telephone
    }
  },

  mounted() {
    const boton = document.getElementById('updateEmailButton')

    const left = this
    // Agregar un listener para el evento focus
    boton.addEventListener('focus', () => {
      const textoescuchar = `${left.$t('general.save')} ${left.$t('profile.email')}`

      left.escucharAudio(textoescuchar)
    })

    const boton2 = document.getElementById('updatePasswordButton')

    // Agregar un listener para el evento focus
    boton2.addEventListener('focus', () => {
      const textoescuchar = `${left.$t('general.save')} ${left.$t('profile.password')}`

      left.escucharAudio(textoescuchar)
    })
  },

  methods: {
    openPasswordPolicyModal() {
      this.showPasswordPolicyModal = true
    },

    closePasswordPolicyModal() {
      this.showPasswordPolicyModal = false
    },

    passwordPolicyError(violation) {
      const count = this.getPasswordPolicy?.[violation]

      return typeof count === 'number' ?
        this.$tc(PASSWORD_POLICY_I18N_KEYS[violation], count, {count}) :
        this.$t(PASSWORD_POLICY_I18N_KEYS[violation])
    },

    validateUpdatePasswordField(field) {
      if (field === 'currentPassword') {
        this.modifyCurrentPasswordError = isCompletedPassword(this.modifyCurrentPassword) ?
          undefined : this.$t('auth.errors.current_password.blank')

        return !this.modifyCurrentPasswordError
      }

      if (field === 'password') {
        if (!isCompletedPassword(this.modifyPassword)) {
          this.modifyPasswordError = this.$t('auth.errors.password.blank')

          return false
        }

        this.modifyPasswordError = this.modifyPasswordPolicyViolation ?
          this.passwordPolicyError(this.modifyPasswordPolicyViolation) : undefined

        return !this.modifyPasswordError
      }

      if (field === 'passwordConfirmation') {
        if (!isCompletedPassword(this.modifyPasswordConfirmation)) {
          this.modifyPasswordConfirmationError =
            this.$t('auth.errors.password_confirmation.confirmation')

          return false
        }

        this.modifyPasswordConfirmationError =
          this.modifyPasswordConfirmation === this.modifyPassword ? undefined :
            this.$t('auth.errors.password_confirmation.confirmation')

        return !this.modifyPasswordConfirmationError
      }

      return true
    },

    validateUpdatePasswordFields() {
      Object.keys(this.modifyPasswordValidationTouched).forEach(field => {
        this.modifyPasswordValidationTouched[field] = true
        this.validateUpdatePasswordField(field)
      })

      return this.isUpdatePasswordSubmitEnabled
    },

    unregisterProcess() {
      if (this.$accounts.length > 0) {
        this.disableMedias = this.$accounts

        this.showDisableMediaBox = true
      } else {
        this.showUnregisterBox = true
      }
    },

    updateData() {
      const vm = this

      // Comprobar si hay cambios
      if (!vm.hasChanges()) {
        vm.$notifications.send({
          id: 'no-changes',
          text: vm.$t('profile.noChanges'),
          type: 'info',
          close: true
        })

        return
      }

      // Validación básica
      vm.modifyNameError = !vm.modifyName ?
        `${vm.$t('profile.name')} ${vm.$t('profile.required')}` : undefined

      vm.modifySurnameError = !vm.modifySurname ?
        `${vm.$t('profile.surname')} ${vm.$t('profile.required')}` : undefined

      vm.modiPhoneError = !vm.modiPhone ?
        `${vm.$t('profile.phone')} ${vm.$t('profile.required')}` : undefined

      // Si hay errores, no continuar
      if (vm.modifyNameError || vm.modifySurnameError || vm.modiPhoneError) {
        return
      }

      // Validación de email se queda como estaba
      if (vm.modifyEmail) {
        vm.modifyEmail = $.trim(vm.modifyEmail)
      }

      vm.modifyEmailError = undefined

      vm.$auth.update({
        email: vm.modifyEmail,
        name: vm.modifyName,
        surname: vm.modifySurname,
        surname2: vm.modifySurname2,
        telephone: vm.modiPhone
      }).then(
        vm.handleUpdateDataSuccess
      ).catch(
        vm.handleUpdateEmailError,
        vm.handleGenericError
      )
    },

    handleUpdateDataSuccess() {
      const vm = this
      const user = vm.$user

      // Comprobar si ha cambiado el email
      if (vm.hasChangeEmail()) {
        vm.$notifications.send({
          id: 'update-email-account-success',
          text: vm.$t('profile.updateEmailAccountSuccess'),
          type: 'success',
          close: true
        })

        vm.$notifications.send({
          id: 'update-security-alert',
          text: vm.$t('profile.updateSecurityAlert'),
          type: 'warning',
          close: true
        })

        // Cerramos la sesión
        this.$auth.logout()
      }

      // Actualizamos los datos del usuario en Vuex
      user.name = vm.modifyName
      user.surname = vm.modifySurname
      user.surname2 = vm.modifySurname2
      user.telephone = vm.modiPhone

      vm.$store.commit('setCurrentUser', user)
      vm.$notifications.send({
        id: 'update-data-success',
        text: vm.$t('profile.updateDataSuccess'),
        type: 'success',
        close: true
      })

      // Comprobar si venimos de incidencias
      if (vm.$store.getters.redirectFromIncidents) {
        vm.$store.commit('setRedirectFromIncidents', false) // Resetear la bandera
        // Esperar 2 segundos antes de redirigir
        setTimeout(() => {
          if (['gc', 'rd', 'vz', 'vl', 'mr'].includes(this.$currentAppConfig.code)) {
            return
          }
          this.$router.push({name: 'municipality-service-channel'})
        }, 3000)
      }
    },

    handleUpdateEmailError(response) {
      if (response.status === 422) {
        this.modifyEmailError = response.data.errors.email
      }
    },

    handleGenericError(response) {
      if (response.status !== 422) {
        vm.$notifications.send({
          id: 'generic-error',
          text: vm.$t('profile.genericError'),
          type: 'error',
          close: true
        })
      }
    },

    updatePassword() {
      const vm = this

      if (vm.modifyCurrentPassword) {
        vm.modifyCurrentPassword = $.trim(vm.modifyCurrentPassword)
      }
      if (vm.modifyPassword) {
        vm.modifyPassword = $.trim(vm.modifyPassword)
      }
      if (vm.modifyPasswordConfirmation) {
        vm.modifyPasswordConfirmation = $.trim(vm.modifyPasswordConfirmation)
      }

      if (!vm.validateUpdatePasswordFields()) return

      vm.$auth.updatePassword({
        current_password: vm.modifyCurrentPassword,
        password: vm.modifyPassword,
        password_confirmation: vm.modifyPasswordConfirmation
      }).then(
        vm.handleUpdatePasswordSuccess,
        vm.handleUpdatePasswordError
      )
    },

    handleUpdatePasswordSuccess() {
      const vm = this
      vm.modifyCurrentPassword = ''
      vm.modifyPassword = ''
      vm.modifyPasswordConfirmation = ''
      vm.$notifications.send({
        id: 'update-password-success',
        text: vm.$t('profile.updatePasswordSuccess'),
        type: 'success',
        close: true
      })
    },

    handleUpdatePasswordError(response) {
      if (response.status === 422) {
        this.modifyCurrentPasswordError = response.data.errors.current_password
        this.modifyPasswordError = response.data.errors.password
        this.modifyPasswordConfirmationError = response.data.errors.password_confirmation
      }
    },

    applyContrasteCss() {
      const DARK_BG = '#1e1e1e'
      const LIGHT_BG = '#ffffff'
      const LIGHT_TEXT = '#ffffff'
      const DARK_TEXT = '#1e1e1e'

      // Helper: aplica estilos múltiples
      const setCss = (selector, styles) => $(selector).css(styles)

      // Helper: limpia estilos
      const resetCss = (selector, props) => {
        const reset = {}
        // eslint-disable-next-line no-return-assign
        props.forEach(p => (reset[p] = ''))
        $(selector).css(reset)
      }

      if (this.contraste) {
        // Texto claro
        setCss(
          '.ns-layout, .ns-layout__header, .text-black, .text-gray2, ' +
          '.sidepanel-map__card--item__stop--route, .sidepanel-map__card--item__stop, ' +
          '.flex-middle, .ns-layout__footer__footer',
          {color: `${LIGHT_TEXT}`}
        )

        // Fondos oscuros
        setCss(
          '.ns-layout, .ns-layout__header, .text-black, .text-gray2, ' +
          '.sidepanel-map__card--item__stop--route, .sidepanel-map__card--item__stop, ' +
          '.sidepanel-map__container, .recharge-home__recharges, .recharge-home__cities, ' +
          '.ns-layout__footer__items, .pb-d6, .sidepanel-map__card--item__point-name, ' +
          '.flex-middle, .sidepanel-map__header, .panel, .ns-tabs',
          {backgroundColor: DARK_BG}
        )

        // Elementos con fondo claro
        setCss(
          '.ns-layout__header--city, .ns-button, .text-info, .ns-icon-youtube, ' +
          '.ns-layout__sidebar__map__menu, .submenuusuario',
          {backgroundColor: LIGHT_BG, color: DARK_TEXT}
        )

        // Casos específicos
        setCss('#iconorestablecer, #textorestablecer', {
          backgroundColor: LIGHT_BG,
          color: DARK_TEXT
        })

        setCss('.button-phone', {border: `2px solid ${LIGHT_TEXT}`})
        setCss('.active', {backgroundColor: 'transparent', border: `2px solid ${DARK_TEXT}`})
      } else {
        // Reset genérico
        resetCss(
          '.ns-layout, .ns-layout__header, .text-black, .text-gray2, ' +
          '.sidepanel-map__card--item__stop--route, .sidepanel-map__card--item__stop, ' +
          '.text-primary, .text-gray2-hover, .button-phone, .text-gray3, ' +
          '.sidepanel-map__container, .recharge-home__recharges, .recharge-home__cities, ' +
          '.ns-layout__footer__items, .pb-d6, .sidepanel-map__card--item__point-name, ' +
          '.panel, .ns-tabs, .submenuusuario, .ns-layout__sidebar__map__menu',
          ['color', 'backgroundColor', 'border']
        )

        // Valores por defecto explícitos
        setCss('#iconorestablecer, #textorestablecer', {
          backgroundColor: LIGHT_BG,
          color: DARK_TEXT
        })
      }
    },

    hasChangeEmail() {
      const vm = this

      return !(vm.modifyEmail === vm.$user.email)
    },

    hasChanges() {
      const vm = this

      return !(
        vm.modifyEmail === vm.$user.email &&
        vm.modifyName === vm.$user.name &&
        vm.modifySurname === vm.$user.surname &&
        vm.modifySurname2 === vm.$user.surname2 &&
        vm.modiPhone === vm.$user.telephone
      )
    }
  }
})
